const mediaApi = [
    {
        image: 'https://daffodilvarsity.edu.bd/gallery/february-2022/ff0500f783d5a57ffcfcee5053570f9f.webp',
        topic: "Mode9i is titiyre ",
        date: '15/jun/2023',
        title: 'ম্যানগ্রোভ ইনস্টিটিউট বর্তমানে 15টি প্রযুক্তিতে 4-বছরের ডিপ্লোমা ইন ইঞ্জিনিয়ারিং কোর্স অফার করে। ',
        place: "shibbari",
    }, {
        image: 'https://daffodilvarsity.edu.bd/gallery/february-2022/ff0500f783d5a57ffcfcee5053570f9f.webp',
        topic: "Mode9i is titiyre ",
        date: '15/jun/2023',
        title: 'ম্যানগ্রোভ ইনস্টিটিউট বর্তমানে 15টি প্রযুক্তিতে 4-বছরের ডিপ্লোমা ইন ইঞ্জিনিয়ারিং কোর্স অফার করে। ডিপ্লোমা ইন ইঞ্জিনিয়ারিং হল বাংলাদেশ কারিগরি শিক্ষা বোর্ড কর্তৃক পরিচালিত একটি 6 মাসের, 6-সেমিস্টারের কোর্স।',
        place: "shibbari",
    }, {
        image: 'https://daffodilvarsity.edu.bd/gallery/february-2022/ff0500f783d5a57ffcfcee5053570f9f.webp',
        topic: "Mode9i is titiyre ",
        date: '15/jun/2023',
        title: 'ম্যানগ্রোভ ইনস্টিটিউট বর্তমানে 15টি প্রযুক্তিতে 4-বছরের ডিপ্লোমা ইন ইঞ্জিনিয়ারিং কোর্স অফার করে।  ',
        place: "shibbari",
    }, {
        image: 'https://daffodilvarsity.edu.bd/gallery/february-2022/ff0500f783d5a57ffcfcee5053570f9f.webp',
        topic: "Mode9i is titiyre ",
        date: '15/jun/2023',
        title: 'ম্যানগ্রোভ ইনস্টিটিউট বর্তমানে 15টি প্রযুক্তিতে 4-বছরের ডিপ্লোমা ইন ইঞ্জিনিয়ারিং কোর্স অফার করে। ডিপ্লোমা ইন ইঞ্জিনিয়ারিং হল বাংলাদেশ কারিগরি শিক্ষা বোর্ড কর্তৃক পরিচালিত একটি 6 মাসের, 6-সেমিস্টারের কোর্স।',
        place: "shibbari",
    }, {
        image: 'https://daffodilvarsity.edu.bd/gallery/february-2022/ff0500f783d5a57ffcfcee5053570f9f.webp',
        topic: "Mode9i is titiyre ",
        date: '15/jun/2023',
        title: 'ম্যানগ্রোভ ইনস্টিটিউট বর্তমানে 15টি প্রযুক্তিতে 4-বছরের ডিপ্লোমা ইন ইঞ্জিনিয়ারিং কোর্স অফার করে। ডিপ্লোমা ইন ইঞ্জিনিয়ারিং হল বাংলাদেশ কারিগরি শিক্ষা বোর্ড কর্তৃক পরিচালিত একটি 6 মাসের, 6-সেমিস্টারের কোর্স।',
        place: "shibbari",
    }, {
        image: 'https://daffodilvarsity.edu.bd/gallery/february-2022/ff0500f783d5a57ffcfcee5053570f9f.webp',
        topic: "Mode9i is titiyre ",
        date: '15/jun/2023',
        title: 'ম্যানগ্রোভ ইনস্টিটিউট বর্তমানে 15টি প্রযুক্তিতে 4-বছরের ডিপ্লোমা ইন ইঞ্জিনিয়ারিং কোর্স অফার করে। ডিপ্লোমা ইন ইঞ্জিনিয়ারিং হল বাংলাদেশ কারিগরি শিক্ষা বোর্ড কর্তৃক পরিচালিত একটি 6 মাসের, 6-সেমিস্টারের কোর্স।',
        place: "shibbari",
    }, {
        image: 'https://daffodilvarsity.edu.bd/gallery/february-2022/ff0500f783d5a57ffcfcee5053570f9f.webp',
        topic: "Mode9i is titiyre ",
        date: '15/jun/2023',
        title: 'ম্যানগ্রোভ ইনস্টিটিউট বর্তমানে 15টি প্রযুক্তিতে 4-বছরের ডিপ্লোমা ইন ইঞ্জিনিয়ারিং কোর্স অফার করে। ডিপ্লোমা ইন ইঞ্জিনিয়ারিং হল বাংলাদেশ কারিগরি শিক্ষা বোর্ড কর্তৃক পরিচালিত একটি 6 মাসের, 6-সেমিস্টারের কোর্স।',
        place: "shibbari",
    }, {
        image: 'https://daffodilvarsity.edu.bd/gallery/february-2022/ff0500f783d5a57ffcfcee5053570f9f.webp',
        topic: "Mode9i is titiyre ",
        date: '15/jun/2023',
        title: 'ম্যানগ্রোভ ইনস্টিটিউট বর্তমানে 15টি প্রযুক্তিতে 4-বছরের ডিপ্লোমা ইন ইঞ্জিনিয়ারিং কোর্স অফার করে। ডিপ্লোমা ইন ইঞ্জিনিয়ারিং হল বাংলাদেশ কারিগরি শিক্ষা বোর্ড কর্তৃক পরিচালিত একটি 6 মাসের, 6-সেমিস্টারের কোর্স।',
        place: "shibbari",
    }, {
        image: 'https://daffodilvarsity.edu.bd/gallery/february-2022/ff0500f783d5a57ffcfcee5053570f9f.webp',
        topic: "Mode9i is titiyre ",
        date: '15/jun/2023',
        title: 'ম্যানগ্রোভ ইনস্টিটিউট বর্তমানে 15টি প্রযুক্তিতে 4-বছরের ডিপ্লোমা ইন ইঞ্জিনিয়ারিং কোর্স অফার করে। ডিপ্লোমা ইন ইঞ্জিনিয়ারিং হল বাংলাদেশ কারিগরি শিক্ষা বোর্ড কর্তৃক পরিচালিত একটি 6 মাসের, 6-সেমিস্টারের কোর্স।',
        place: "shibbari",
    }, {
        image: 'https://daffodilvarsity.edu.bd/gallery/february-2022/ff0500f783d5a57ffcfcee5053570f9f.webp',
        topic: "Mode9i is titiyre ",
        date: '15/jun/2023',
        title: 'ম্যানগ্রোভ ইনস্টিটিউট বর্তমানে 15টি প্রযুক্তিতে 4-বছরের ডিপ্লোমা ইন ইঞ্জিনিয়ারিং কোর্স অফার করে। ডিপ্লোমা ইন ইঞ্জিনিয়ারিং হল বাংলাদেশ কারিগরি শিক্ষা বোর্ড কর্তৃক পরিচালিত একটি 6 মাসের, 6-সেমিস্টারের কোর্স।',
        place: "shibbari",
    }, {
        image: 'https://daffodilvarsity.edu.bd/gallery/february-2022/ff0500f783d5a57ffcfcee5053570f9f.webp',
        topic: "Mode9i is titiyre ",
        date: '15/jun/2023',
        title: 'ম্যানগ্রোভ ইনস্টিটিউট বর্তমানে 15টি প্রযুক্তিতে 4-বছরের ডিপ্লোমা ইন ইঞ্জিনিয়ারিং কোর্স অফার করে। ডিপ্লোমা ইন ইঞ্জিনিয়ারিং হল বাংলাদেশ কারিগরি শিক্ষা বোর্ড কর্তৃক পরিচালিত একটি 6 মাসের, 6-সেমিস্টারের কোর্স।',
        place: "shibbari",
    }
]
export default mediaApi